export const UPDATE_USER = "UPDATE_USER";
export const LOGIN_USER = "LOGIN_USER";
export const SET_USER_LOADING = "SET_USER_LOADING";
export const SET_AUTH_LOADING = "SET_AUTH_LOADING";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const AUTH_ERROR = "AUTH_ERROR";
export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_ERROR = "VERIFY_OTP_ERROR";
export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD";
export const VERIFY_RESET_CODE = "VERIFY_RESET_CODE";
export const COMPLETE_REGISTRAION = "COMPLETE_REGISTRAION";
export const CREATE_BENEFICIARY = "CREATE_BENEFICIARY";
export const UPDATE_BENEFICIARY = "UPDATE_BENEFICIARY";
export const GET_BENEFICIARY = "GET_BENEFICIARY";
export const GET_SINGLE_BENEFICIARY = "GET_SINGLE_BENEFICIARY";
